import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  MapPin,
  Navigation2,
  Clock,
  ChevronRight,
  Package,
  User,
  Phone,
  MoreVertical,
  Play,
  Pause,
} from 'lucide-react';

const RoutesPage = () => {
  const [isNavigating, setIsNavigating] = useState(false);

  const currentRoute = {
    stops: [
      {
        id: 1,
        customer: 'John Smith',
        address: '123 Main St, Suite 4B',
        phone: '+1 234-567-8900',
        eta: '10:30 AM',
        status: 'Next',
      },
      {
        id: 2,
        customer: 'Sarah Johnson',
        address: '456 Park Ave',
        phone: '+1 234-567-8901',
        eta: '11:15 AM',
        status: 'Pending',
      },
      {
        id: 3,
        customer: 'Mike Brown',
        address: '789 Broadway',
        phone: '+1 234-567-8902',
        eta: '12:00 PM',
        status: 'Pending',
      },
    ],
    totalDistance: '15.5 km',
    estimatedTime: '45 mins',
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* Map Area (Left Side) */}
      <div className="lg:col-span-2 bg-white rounded-lg shadow-sm p-4 h-[calc(100vh-8rem)]">
        <div className="bg-gray-100 h-full rounded-lg flex items-center justify-center">
          {/* Replace this with actual map integration */}
          <div className="text-gray-500 text-center">
            <Navigation2 className="w-12 h-12 mx-auto mb-2" />
            <p>Map Integration Goes Here</p>
          </div>
        </div>
      </div>

      {/* Route Details (Right Side) */}
      <div className="space-y-4">
        {/* Route Summary */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-lg shadow-sm p-4"
        >
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-800">Today's Route</h3>
            <button
              onClick={() => setIsNavigating(!isNavigating)}
              className={`px-4 py-2 rounded-lg ${
                isNavigating
                  ? 'bg-red-100 text-red-600'
                  : 'bg-emerald-100 text-emerald-600'
              }`}
            >
              {isNavigating ? (
                <div className="flex items-center space-x-2">
                  <Pause className="w-4 h-4" />
                  <span>Stop</span>
                </div>
              ) : (
                <div className="flex items-center space-x-2">
                  <Play className="w-4 h-4" />
                  <span>Start</span>
                </div>
              )}
            </button>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-gray-50 p-3 rounded-lg">
              <p className="text-sm text-gray-600">Total Distance</p>
              <p className="text-lg font-semibold text-gray-800">
                {currentRoute.totalDistance}
              </p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg">
              <p className="text-sm text-gray-600">Estimated Time</p>
              <p className="text-lg font-semibold text-gray-800">
                {currentRoute.estimatedTime}
              </p>
            </div>
          </div>
        </motion.div>

        {/* Stops List */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Stops</h3>
          <div className="space-y-4">
            {currentRoute.stops.map((stop, index) => (
              <motion.div
                key={stop.id}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                className="flex items-start space-x-4 p-3 rounded-lg hover:bg-gray-50"
              >
                <div
                  className={`p-2 rounded-full ${
                    stop.status === 'Next'
                      ? 'bg-emerald-100 text-emerald-600'
                      : 'bg-gray-100 text-gray-600'
                  }`}
                >
                  <MapPin className="w-5 h-5" />
                </div>
                <div className="flex-1">
                  <div className="flex items-start justify-between">
                    <div>
                      <p className="font-medium text-gray-800">{stop.customer}</p>
                      <p className="text-sm text-gray-600">{stop.address}</p>
                    </div>
                    <p className="text-sm text-gray-500">{stop.eta}</p>
                  </div>
                  <div className="mt-2 flex items-center space-x-4 text-sm text-gray-600">
                    <span className="flex items-center space-x-1">
                      <Phone className="w-4 h-4" />
                      <span>{stop.phone}</span>
                    </span>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoutesPage;